import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedGPA4to5 from "./SharedGPA4to5";
import SharedGPA5to4 from "./SharedGPA5to4";
const TITLE = "تحويل وحساب المعدل التراكمي من 4 الى 5 وبالعكس";
const DESCRIPTION =
  "احسب المعدل التراكمي بين 4 و 5 نقاط والعكس بسهولة باستخدام هذه الحاسبة. تعرّف على كيفية حساب المعدل التراكمي بين 4 و 5 نقاط بدقة.";
const KEYWORDS =
  "حساب المعدل التراكمي من 4 الى 5, حاسبة المعدل التراكمي, حساب المعدل من 4 الى 5, حساب المعدل التراكمي بالعكس";
const OG_URL = "https://do-calculate.com/calculator/ar/gpa4to5";
function GPA4() {
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>{DESCRIPTION}</p>
                <p>
                  توفر لك هذه الحاسبة إمكانية تحويل وحساب المعدل التراكمي من 4 إلى 5
                  نقاط أو تحويل المعدل من 5 إلى 4 بسهولة ودقة عالية. إذا كنت طالبًا
                  جامعيًا أو خريجًا وتحتاج إلى معادلة المعدل التراكمي (GPA) للتقديم على
                  جامعة، منحة دراسية، أو وظيفة، يمكنك استخدام هذه الأداة لحساب المعدل
                  بسرعة وبدون أخطاء.
                </p>

                <p>
                  تساعدك حاسبة المعدل التراكمي هذه على معرفة طريقة حساب المعدل من 4 إلى
                  5 والعكس باستخدام المعادلة المعتمدة، حيث يتم ضرب أو قسمة المعدل حسب نظام
                  التقييم المستخدم في جامعتك. كما يمكنك التأكد من صحة تحويل المعدل
                  التراكمي قبل تقديم مستنداتك الرسمية.
                </p>

                <p>
                  سواء كنت تبحث عن طريقة تحويل GPA من نظام 4.0 إلى 5.0 أو ترغب في حساب
                  المعدل التراكمي بالعكس، فإن هذه الأداة توفر لك الحل الأسرع والأدق عبر
                  إدخال المعدل الحالي والحصول على النتيجة فورًا.
                </p>
              </div>
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="row">
              <div className="col">
                <SharedGPA4to5 />
              </div>
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <SharedGPA5to4 />
              </div>
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={600}></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE} </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      جدول تحويل المعدل التراكمي من 4 الى 5 و بالعكس{" "}
                    </h2>{" "}
                  </u>
                  <table >
                    <tbody>
                      <tr className="gpa-header">
                        <th>4.0 Scale</th>
                        <th>5.0 Scale</th>
                      </tr>
                      <tr>
                        <td>3.97 ~ 4.0</td>
                        <td>4.95 ~ 5.00</td>
                      </tr>
                      <tr>
                        <td>3.92 ~ 3.96</td>
                        <td>4.90 ~ 4.94</td>
                      </tr>
                      <tr>
                        <td>3.88 ~ 3.91</td>
                        <td>4.84 ~ 4.89</td>
                      </tr>
                      <tr>
                        <td>3.84 ~ 3.87</td>
                        <td>4.79 ~ 4.83</td>
                      </tr>
                      <tr>
                        <td>3.80 ~ 3.83</td>
                        <td>4.73 ~ 4.78</td>
                      </tr>
                      <tr>
                        <td>3.75 ~ 3.79</td>
                        <td>4.68 ~ 4.72</td>
                      </tr>
                      <tr>
                        <td>3.71 ~ 3.74</td>
                        <td>4.62 ~ 4.67</td>
                      </tr>
                      <tr>
                        <td>3.67 ~ 3.70</td>
                        <td>4.57 ~ 4.61</td>
                      </tr>
                      <tr>
                        <td>3.62 ~ 3.66</td>
                        <td>4.51 ~ 4.56</td>
                      </tr>
                      <tr>
                        <td>3.58 ~ 3.61</td>
                        <td>4.45 ~ 4.50</td>
                      </tr>
                      <tr>
                        <td>3.49 ~ 3.57</td>
                        <td>4.34 ~ 4.44</td>
                      </tr>
                      <tr>
                        <td>3.41 ~ 3.48</td>
                        <td>4.23 ~ 4.33</td>
                      </tr>
                      <tr>
                        <td>3.32 ~ 3.40</td>
                        <td>4.12 ~ 4.22</td>
                      </tr>
                      <tr>
                        <td>3.24 ~ 3.31</td>
                        <td>4.01 ~ 4.11</td>
                      </tr>
                      <tr>
                        <td>3.15 ~ 3.23</td>
                        <td>3.90 ~ 4.00</td>
                      </tr>
                      <tr>
                        <td>3.07 ~ 3.14</td>
                        <td>3.79 ~ 3.89</td>
                      </tr>
                      <tr>
                        <td>2.98 ~ 3.06</td>
                        <td>3.68 ~ 3.78</td>
                      </tr>
                      <tr>
                        <td>2.90 ~ 2.97</td>
                        <td>3.57 ~ 3.67</td>
                      </tr>
                      <tr>
                        <td>2.81 ~ 2.89</td>
                        <td>3.45 ~ 3.56</td>
                      </tr>
                      <tr>
                        <td>2.72 ~ 2.80</td>
                        <td>3.34 ~ 3.44</td>
                      </tr>
                      <tr>
                        <td>2.64 ~ 2.71</td>
                        <td>3.23 ~ 3.33</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GPA4;
